<template>
    <va-edit-layout>
        <CouponPaymentEventFee-form
            :id="id"
            :title="title"
            :item="item"
        ></CouponPaymentEventFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
